module.exports = __webpack_public_path__ + "img/special-spcialities.ae74cb46.svg";